export const energyContent = {
    id: "energy",
    route: "/energetika",
    menuTitle: "Energetika",
    title: "Energetika a elektromobilita",
    headline: "Moderní energetická infrastruktura pro města a firmy",
    lead: "Dodáváme a servisujeme energetická řešení pro města, firmy a technologické projekty.",
    summary: "Zaměřujeme se na nabíjecí infrastrukturu, bateriová úložiště, FVE, ostrovní systémy, energetické kontejnery a vzdálený dohled.",
    primaryItems: [
        "nabíjecí kiosky V1 a V2",
        "veřejné nabíjecí stanice",
        "bateriová úložiště",
        "fotovoltaické elektrárny",
        "ostrovní systémy",
        "energetické kontejnery",
        "vzdálený dohled a servis"
    ],
    sections: [
        {
            title: "Služby",
            items: [
                "nabíjecí kiosky V1 a V2",
                "veřejné nabíjecí stanice",
                "bateriová úložiště",
                "fotovoltaické elektrárny",
                "ostrovní systémy",
                "energetické kontejnery",
                "vzdálený dohled a servis"
            ]
        }
    ]
};
